import React, { useState, useEffect } from 'react'
import "../../styles/pelvicCareProgram.css"
import { PelvicProgramBanner1 } from '../../components/PelvicProgramBanner1'
import { PelvicProgramBanner2 } from '../../components/PelvicProgramBanner2'
import { PelvicProgramBanner3 } from '../../components/PelvicProgramBanner3'
import { PelvicProgramBanner4 } from '../../components/PelvicProgramBanner4'
import { PelvicProgramBanner5 } from '../../components/PelvicProgramBanner5'
import { PelvicProgramBanner6 } from '../../components/PelvicProgramBanner6'
import { PelvicProgramBanner7 } from '../../components/PelvicProgramBanner7'
import { NewFooter } from "../../components/newFooter"
import PelvicProgramBanner8 from '../../components/PelvicProgramBanner8'


function PelvicCareProgram() {

  const getWindowDimensions = () => {
    const { innerWidth: width } = window;
    return {
      width,
    };
  };

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });

  return (
    <div>
       <PelvicProgramBanner1 width={windowDimensions.width} />
       <PelvicProgramBanner2 width={windowDimensions.width} />
       <PelvicProgramBanner3 width={windowDimensions.width} />
       <PelvicProgramBanner4 width={windowDimensions.width} />
       <PelvicProgramBanner5 width={windowDimensions.width} />
       <PelvicProgramBanner6 width={windowDimensions.width} />
       <PelvicProgramBanner7 width={windowDimensions.width} />
       <PelvicProgramBanner8 width={windowDimensions.width} />
       <NewFooter/>
    </div>
  )
}

export default PelvicCareProgram